<!--
 * @Title: 标题
 * @Description: 描述网站
 * @Author: xulongyong
 * @Date: 2023-09-10 10:02:06
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-10 10:02:09
 * @FilePath: \vue-privilege-routing\src\pages\resource\website-manage\index.vue
-->
<template>
    <div>
       网站管理
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
